import { WhatsappIcon } from "@/components/icons/WhatsappIcon";
import { buildWhatsappLink, WHATSAPP_PARCEIROS } from "@/lib/whatsapp";

interface AssessoresCTAFinalProps {
  /** A /assessores-v2 encerra a página só com a mensagem — o contato acontece no form da primeira dobra. */
  showWhatsapp?: boolean;
}

export const AssessoresCTAFinal = ({
  showWhatsapp = true,
}: AssessoresCTAFinalProps) => {
  return (
    <section className="bg-[#FAF8F5] py-16 sm:py-20 md:py-24">
      <div className="container-narrow px-6 sm:px-6 md:px-12 text-center">
        <h2
          className="font-extrabold leading-[1.15] tracking-tight text-[#323F4F] text-2xl sm:text-3xl md:text-4xl max-w-2xl mx-auto"
          style={{
            fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
            letterSpacing: "-0.03em",
          }}
        >
          Se você acredita em transparência, relacionamento de longo prazo e
          investimentos com lastro real,{" "}
          <span className="text-[#2E694D]">a Allu é a parceria certa</span>{" "}
          para o seu próximo nível profissional.
        </h2>

        {showWhatsapp && (
          <div className="mt-8">
            <a
              href={buildWhatsappLink(
                "Olá! Vim pela página de parceiros da Allu e quero saber mais sobre o programa.",
                WHATSAPP_PARCEIROS
              )}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#2E694D] hover:bg-[#255A41] text-[#FAFAFA] text-sm font-medium px-[18px] py-3.5 transition-colors"
            >
              <WhatsappIcon className="w-4 h-4" />
              Falar com a Allu
            </a>
          </div>
        )}
      </div>
    </section>
  );
};
